import React, { useEffect, useState } from 'react'
import { Image, ImageBackground, Platform } from 'react-native'

import { useModal } from '@zet/common/hooks/useModal'
import { getSessionData } from '@zet/common/utils/getSessionData'
// import { getSvgIcon } from '@zet/feature-brands/utils'
import Language from '@zet/customer/assets/svgs/language.svg'
import { useAgentDetailsWF } from '@zet/customer/src/api/hooks/webFlow'
import { Icon } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B4, H3, H5, SH4 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'
import WebFlowLanguageFilled from '@zet/svg/webFlowLanguageFilled'

import {
  MAG_HEAD_MID_BG,
  MAG_HEAD_UPPER_BG,
  MAG_LOGO,
} from '../../../assets/magnet'
import useAddCustomerStore from '../../store/addCustomer'
import { CATEGORY, URL_PATH } from '../../utils/addCustomerStates'
import checkIsMagnetFlow from '../../utils/checkIsMagnetFlow'
import Header from './Header'
import { ContentList } from './contentList'

const CategoryIcon = ({ categoryType }) => {
  if (categoryType === CATEGORY.CREDIT_CARD)
    return (
      <Image
        source={require('../../../assets/images/cc.webp')}
        style={{ width: 82, height: 63 }}
        resizeMode="contain"
      />
    )
  if (categoryType === CATEGORY.LOANS)
    return (
      <Image
        style={{ width: 63, height: 63 }}
        source={require('../../../assets/images/loan.webp')}
      />
    )

  return (
    <Image
      style={{ width: 90, height: 63 }}
      resizeMode="contain"
      source={require('../../../assets/images/generic.webp')}
    />
  )
}

const AddCustomerHeader = () => {
  const [svgHeight, setSvgHeight] = useState(0)
  const { setCustomerName, setCustomerPhoneNumber, setBrandSpecificPartnerId } =
    useAddCustomerStore()
  // const { mutate } = useSetTokenForCustomer()

  const { data } = useAgentDetailsWF()
  const isCreditScoreCheckFlow =
    getSessionData('isCreditScoreCheck')?.toString() === 'true'
  // const urlParams = new URLSearchParams(window.location.search)
  // const customerId = urlParams.get('customerId')
  // const { data: content } = useBrandDetailsById(Number(data?.partnerId))
  const isMagnetFlow = checkIsMagnetFlow()
  useEffect(() => {
    if (data?.customer) {
      setCustomerName(data?.customer?.fullName)
      setCustomerPhoneNumber(String(data?.customer?.phoneNumber))
    }
    if (data?.partnerId) {
      setBrandSpecificPartnerId(data?.partnerId)
    }
  }, [isCreditScoreCheckFlow, data])

  const { openModal } = useModal()

  const handlePress = () => {
    openModal('WebFlowSelectorModal', {
      title: i18n.t('appLanguage.choose'),
      iconName: 'BankOutlined',
      criteriaName: 'languageModal',
      options: ['English', 'Hindi'],
    })
  }

  const PoweredBy = () => {
    return (
      <XStack className="items-center">
        <SH4 className="text-[80] text-white ">
          {i18n.t('webFlow.addCustomerHeader.powered')}
        </SH4>

        <Image
          source={MAG_LOGO}
          style={{
            width: 36,
            height: 12,
          }}
          resizeMode="contain"
        />
      </XStack>
    )
  }

  const GenericMagnetHeader = () => {
    return (
      <Stack>
        <ImageBackground source={MAG_HEAD_UPPER_BG}>
          <XStack className="ml-4/2 items-center justify-between">
            <Stack>
              <H3 className="flex-1 font-[Graphie-Bold] text-xl text-white ">
                {data?.headerName[i18n.locale]}
              </H3>
              <PoweredBy />
            </Stack>
            <Stack className="mt-2">
              <CategoryIcon categoryType={data?.categoryType} />
            </Stack>
          </XStack>
        </ImageBackground>
        <ImageBackground source={MAG_HEAD_MID_BG}>
          <XStack className="p-4/2 items-center justify-between ">
            <ContentList
              isMagnetFlow
              content={data?.headerContent}
              language={i18n.locale}
            />
            <Pressable
              onPress={handlePress}
              className="bg-primary-30 self-start rounded bg-white px-2 py-1"
            >
              <XStack>
                <Language />
                <B4 className="ml-1 ">
                  {i18n.t('webFlow.addCustomerHeader.locale')}
                </B4>
              </XStack>
            </Pressable>
          </XStack>
        </ImageBackground>
      </Stack>
    )
  }

  const MagnetCreditHeader = () => {
    return (
      <Stack>
        <ImageBackground className="p-3" source={MAG_HEAD_UPPER_BG}>
          <XStack className="items-center justify-between">
            <Stack>
              <H5 className="flex-1 text-white">
                {i18n.t('creditScore.heading')}
              </H5>
              <PoweredBy />
            </Stack>

            {URL_PATH.includes(window.location.pathname) && (
              <Pressable onPress={handlePress}>
                <WebFlowLanguageFilled />
              </Pressable>
            )}
          </XStack>
        </ImageBackground>
      </Stack>
    )
  }

  const onLayout = ({ nativeEvent }) => {
    if (Platform.OS === 'web') {
      setSvgHeight(nativeEvent.layout.height)
    }
  }
  if (data?.bannerUrl) {
    if (data?.customer?.verified) {
      return (
        <XStack
          className="items-center justify-between gap-x-3 border-b border-b-[#FFFFFF33] p-3"
          style={{ backgroundColor: '#26378A' }}
        >
          <H3 className="flex-1 font-[Graphie-Bold] text-xl text-white">
            {data?.headerName[i18n.locale]}
          </H3>
          <Pressable
            onPress={handlePress}
            className="bg-primary-100 px-4/2 rounded py-1"
          >
            <XStack>
              <Icon type="LanguageOutlined" color="#FFF" />
              <B4 className="ml-1 text-white">
                {i18n.t('webFlow.addCustomerHeader.locale')}
              </B4>
            </XStack>
          </Pressable>
        </XStack>
      )
    }
    return <></>
  }

  if (isMagnetFlow && !isCreditScoreCheckFlow) return <GenericMagnetHeader />
  else if (isMagnetFlow && isCreditScoreCheckFlow) return <MagnetCreditHeader />
  return (
    <React.Fragment>
      {!isCreditScoreCheckFlow && (
        <Stack onLayout={onLayout}>
          {Platform.OS === 'web' && (
            <Stack className="absolute">
              <Header
                width={Math.min(window.innerWidth, 640)}
                height={svgHeight}
              />
            </Stack>
          )}

          <XStack className="items-center justify-between gap-x-3 border-b border-b-[#FFFFFF33] p-3">
            <H3 className="flex-1 font-[Graphie-Bold] text-xl text-white">
              {data?.headerName?.[i18n.locale]}
            </H3>
            <Pressable
              onPress={handlePress}
              className="bg-primary-100 px-4/2 rounded py-1"
            >
              <XStack>
                <Icon type="LanguageOutlined" color="#FFF" />
                <B4 className="ml-1 text-white">
                  {i18n.t('webFlow.addCustomerHeader.locale')}
                </B4>
              </XStack>
            </Pressable>
          </XStack>
        </Stack>
      )}
      {isCreditScoreCheckFlow && (
        <Stack>
          <Stack className="bg-tertiary-150 p-3">
            <XStack className="items-center justify-between">
              <H5 className="flex-1 text-white">
                {i18n.t('creditScore.heading')}
              </H5>

              {URL_PATH.includes(window.location.pathname) && (
                <Pressable onPress={handlePress}>
                  <WebFlowLanguageFilled />
                </Pressable>
              )}
            </XStack>
          </Stack>
        </Stack>
      )}
    </React.Fragment>
  )
}

export default AddCustomerHeader
